
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prime",
      function () {
        return require("private-next-pages/prime.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prime"])
      });
    }
  